import axios from 'axios';
import { UserModel } from '../Models/UserModel';

const createFirstAccess = (params: UserModel) =>
  axios.post('auth/first-access', params);
const login = (params: UserModel) => axios.post('auth/login', params);
const loginWithSSO = (ssoData: {
  accessToken: string;
  account: any;
  user: {
    id: string;
    email: string;
    name: string;
  };
}) => axios.post('auth/login-sso', ssoData);
const checkIfMetricUsernameExists = (params: string) =>
  axios.get(`auth/${params}/exists`);

const sendEmailPasswordRecovery = (params: UserModel) =>
  axios.post('auth/send-email-password-recovery', params);
const verifyCodePasswordRecovery = (params: UserModel) =>
  axios.post('auth/verify-code-password-recovery', params);
const changePassword = (params: UserModel, token: string) =>
  axios.post('auth/change-password', params, {
    headers: { Authorization: `Bearer ${token}` },
  });

export default {
  login,
  loginWithSSO,
  createFirstAccess,
  checkIfMetricUsernameExists,
  sendEmailPasswordRecovery,
  verifyCodePasswordRecovery,
  changePassword,
};
